(() => {
  const MOBILE_QUERY = '(max-width: 1024px)';

  const isMobile = () => window.matchMedia(MOBILE_QUERY).matches;

  const setExpandedState = (details, open) => {
    if (!details) return;

    if (open) {
      details.setAttribute('open', '');
      details.classList.add('menu-opening');
    } else {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
      details.querySelectorAll('details[open]').forEach((child) => {
        child.removeAttribute('open');
        child.classList.remove('menu-opening');
        child.querySelector(':scope > summary')?.setAttribute('aria-expanded', 'false');
      });
    }

    details.querySelector(':scope > summary')?.setAttribute('aria-expanded', open ? 'true' : 'false');
  };

  const siblingDetails = (details) => {
    const list = details.closest('ul');
    if (!list) return [];

    return Array.from(list.children)
      .map((item) => item.querySelector(':scope > details'))
      .filter(Boolean);
  };

  const openPathToDefault = (drawer, defaultDetails) => {
    if (!isMobile() || !defaultDetails) return;

    const path = [];
    let current = defaultDetails;

    while (current && current !== drawer) {
      if (current.matches?.('details') && current.id !== 'Details-menu-drawer-container') {
        path.unshift(current);
      }
      current = current.parentElement?.closest('details');
    }

    path.forEach((details) => {
      siblingDetails(details).forEach((sibling) => {
        if (sibling !== details && sibling.open) setExpandedState(sibling, false);
      });
      setExpandedState(details, true);
    });
  };

  const initDrawer = (drawer) => {
    if (!drawer || drawer.dataset.pfAccordionInit === 'true') return;
    drawer.dataset.pfAccordionInit = 'true';

    const rootDetails = drawer.querySelector('#Details-menu-drawer-container');
    const menuDetails = Array.from(
      drawer.querySelectorAll('.menu-drawer__navigation details')
    );
    const defaultDetails = menuDetails.find((details) => details.hasAttribute('data-pf-mobile-default-open'));

    const openDefaultIfNeeded = () => {
      if (!isMobile() || !defaultDetails) return;

      const defaultPathAlreadyOpen = defaultDetails.open;
      const anyTopLevelOpen = Array.from(
        drawer.querySelectorAll('.menu-drawer__navigation > .menu-drawer__menu > li > details')
      ).some((details) => details.open);

      if (!defaultPathAlreadyOpen && !anyTopLevelOpen) {
        openPathToDefault(drawer, defaultDetails);
      }
    };

    menuDetails.forEach((details) => {
      details.addEventListener('toggle', () => {
        if (!isMobile() || !details.open) return;

        siblingDetails(details).forEach((otherDetails) => {
          if (otherDetails !== details && otherDetails.open) {
            setExpandedState(otherDetails, false);
          }
        });
      });
    });

    rootDetails?.addEventListener('toggle', () => {
      if (rootDetails.open) {
        window.requestAnimationFrame(openDefaultIfNeeded);
      }
    });

    if (rootDetails?.open) openDefaultIfNeeded();
  };

  const init = () => document.querySelectorAll('header-drawer').forEach(initDrawer);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
